// extracted by mini-css-extract-plugin
export default {"container":"notfound_container__y4Vf8"};